const selector = '#ProductGridContainer';
let cacheManager = {};

window.addEventListener('pageshow', function (e) {
  onLoad(e);
});

function onLoad(e) {
  cacheManager = new PageCacheManager({
    bodySelector: selector,
    onLoaded: onLoadedCache,
    onCached: onCachedCache,
  });

  if (!e.persisted) {
    document.addEventListener('click', function (e) {
      const closest = e.target.closest('.product-loop .card-wrapper a');
      if (closest) cacheManager.cachePage();
    });
  }
  const allItems = e.target.querySelectorAll('.grid__item');
  allItems.forEach(element => {
    element.classList.remove('.scroll-trigger--offscreen');
    element.setAttribute("style", "opacity: 1 !important;");
    
  });
}

function infiniteScrollCollection() {
  var endlessScroll = new Ajaxinate({
    container: '.product-loop',
    pagination: '#CollectionPagination',
    method: 'scroll',
    loadingText: '',
    offset: 0,
    callback: productCardsSizes,
  });
}

function onLoadedCache(e) {
  console.log('loaded');
  infiniteScrollCollection();
  productCardsSizes();
  const allCards = document.querySelector('#product-grid').querySelectorAll('.grid__item');
  allCards.forEach((item) => {
    const itemCard = item.querySelector('.card-wrapper');
    if(itemCard.classList.contains('hovered')) {
      itemCard.classList.remove('hovered')
    }
  })
  document.querySelector(selector).style.visibility = 'visible';
  const allItems = e.target.querySelectorAll('.grid__item');
  allItems.forEach(element => {
    element.classList.remove('.scroll-trigger--offscreen')
    element.setAttribute("style", "opacity: 1 !important;");
  });
  initializeSwipers(backward = true);
}

function onCachedCache(e) {
  console.log('cached');
}
